import React, { useMemo, useContext } from 'react';
import { getHasElementsInArray } from 'utils';
import NotificationPlaceholder from 'components/NotificationPlaceholder';
import LeadNotificationsContext from 'providers/LeadNotifications/LeadNotifications.context';
import LeadNotificationCard from 'components/LeadNotificationCard';
import NotificationsContext from 'providers/Notifications/Notifications.context';

export default function useLeadNotifications() {
  const { setIsDrawerOpen } = useContext(NotificationsContext);
  const { notifications, fetchingNotifications, numberOfPlaceholders } =
    useContext(LeadNotificationsContext);

  const showEmptyState = useMemo(
    () => !fetchingNotifications && !getHasElementsInArray(notifications),
    [fetchingNotifications, notifications],
  );

  const placeholders = useMemo(
    () => (
      <div className="notifications-placeholders">
        {fetchingNotifications &&
          Array(numberOfPlaceholders)
            .fill(1)
            .map((_, i) => <NotificationPlaceholder key={i} />)}
      </div>
    ),
    [fetchingNotifications, numberOfPlaceholders],
  );

  const renderedCards = useMemo(
    () =>
      notifications.map((notification) => (
        <LeadNotificationCard
          key={notification._id}
          notification={notification}
          onDealClick={() => setIsDrawerOpen(false)}
        />
      )),
    [notifications, setIsDrawerOpen],
  );

  return { showEmptyState, placeholders, renderedCards };
}
